import React from "react";
import "./Footer.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { SiLinkedin } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { BsInstagram } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";


const d = new Date();
let year = d.getFullYear()


export default class Footer extends React.Component {






	render() {
		return (
			<>
				<div className="footer">
					<div className="footer__content">
						<h3>Portfolio</h3>
						<p>
							{" "}
							Thank you for visiting and reading my portfolio all the way
							through. If you want to reach out and know more about me, here are
							other ways to do so.{" "}
						</p>

						<ul className="footer__socials">
							<li>
								<a
									href="https://www.linkedin.com/in/syntax-read3r/"
									target="_blank"
									rel="noreferrer"
								>
									{" "}
									<SiLinkedin className="footer__icon" />
								</a>
							</li>
							<li>
								<a
									href="https://twitter.com/munyaChikara"
									target="_blank"
									rel="noreferrer"
								>
									{" "}
									<BsTwitter className="footer__icon" />
								</a>
							</li>
							<li>
								<a
									href="https://github.com/Syntax-Read3r"
									target="_blank"
									rel="noreferrer"
								>
									{" "}
									<VscGithub className="footer__icon" />
								</a>
							</li>
							<li>
								<a href="https://www.instagram.com/munya_chikara/" target="_blank">
									{" "}
									<BsInstagram className="footer__icon" />
								</a>
							</li>
						</ul>
					</div>
					<div className="footer__bottom">
						<p>
							copyright &copy; {year} Munyaradzi Chikara. Designed by{" "}
							<span>Syntax-Read3r</span>
						</p>
					</div>
				</div>

				{/* empty div */}
				<div className="empty"></div>
			</>
		);
	}
}
